import { useState } from 'react';
import { Zap, ChevronDown, ChevronUp } from 'lucide-react';

export default function AIAttentionLayer({ aiPrompts, summary }) {
  const [collapsed, setCollapsed] = useState(false);

  if (!aiPrompts || aiPrompts.length === 0) return null;

  const riskLevel = summary?.riskLevel || 'LOW';
  const isAlert = riskLevel === 'HIGH' || riskLevel === 'MEDIUM';

  return (
    <div data-testid="ai-attention-layer" className="px-4 py-2.5"
      style={{
        background: isAlert ? 'var(--pd-crimson-soft)' : 'var(--pd-blue-soft)',
        borderTop: `1px solid ${isAlert ? 'rgba(180,35,58,0.2)' : 'rgba(37,99,235,0.2)'}`,
      }}>
      <button onClick={() => setCollapsed(!collapsed)}
        className="w-full flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <Zap className="w-3 h-3" style={{ color: isAlert ? 'var(--pd-crimson)' : 'var(--pd-focus)' }} />
          <span className="text-[10px] font-semibold uppercase tracking-[0.06em]"
            style={{ color: isAlert ? 'var(--pd-crimson)' : 'var(--pd-focus)' }}>
            AI Attention
          </span>
        </div>
        {collapsed
          ? <ChevronDown className="w-3 h-3" style={{ color: 'var(--pd-subtle)' }} />
          : <ChevronUp className="w-3 h-3" style={{ color: 'var(--pd-subtle)' }} />}
      </button>

      {!collapsed && (
        <div className="mt-2 space-y-1">
          {aiPrompts.map((prompt, i) => (
            <div key={`prompt-${prompt.slice(0, 20)}-${i}`} className="text-[11px] leading-relaxed" style={{ color: 'var(--pd-muted)' }}>
              {prompt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
